import { gql } from '@apollo/client';

import {
  EndMobileSessionDocument,
  type EndMobileSessionMutation,
  type EndMobileSessionMutationVariables,
} from '../__generated__/documents';

if (false) {
  gql`
    mutation EndMobileSession($input: EndMobileSessionInput!) {
      endMobileSession(input: $input)
    }
  `;
}

export const END_MOBILE_SESSION = EndMobileSessionDocument;
export type { EndMobileSessionMutation, EndMobileSessionMutationVariables };
